<template>
  <button class="record-button"
    :class="{'disabled' : disabled}">
    <div class="recoding"
        v-if="isRecording || isPaused">
      <diV class="record-text">REC</div>
      <div class="record-time">{{ recordingFormedTime }}</div>
    </div>
    <div class="record-controls"
         v-if="isRecording || isPaused" >
      <ul class="record-control-list">
        <li class="record-control-item">
          <button v-if="isPaused" class="record-control-button resume" @click="onRecordResume"></button>
          <button v-if="isRecording" class="record-control-button pause" @click="onRecordPause"></button>
        </li>
        <li class="record-control-item">
          <button class="record-control-button stop" @click="onRecordStop"></button>
        </li>
      </ul>
    </div>
    <div class="inactive"
         :class="{'disabled' : disabled}"
         v-else         
         @click="onRecordStart">REC</div>
  </button>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {gooroomeeMediaExtension} from '@/lib/gooroomee/webrtc/GooroomeeMediaExtension'
import { PcApp } from '@/core/api/pc.app.api';
import moment from "moment";
import {clone} from "lodash/lang";

export default {
  name: 'BtnRecord',
  data() {
    return {
      spendingTime: 0,
      timerIntervalId: null,
      timerIntervalTerm: 100,
    }
  },
  watch: {
    recordState: {
        immediate: true,
        handler: function(){
          if(this.isPaused){
              this.timerPuase()
          } else if(this.isInactive){
              this.timerStop()
          } else if(this.isRecording){
              this.timerStart()
          }
      }
    }
  },
  created() {
    this._Events = clone(_Events);
    this.$roomApi.addEventListeners(this._Events, this);
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
  computed: {
    ...mapGetters('user', [
        'isGuest',
        'hasEmceeRole',
    ]),
    ...mapGetters('record', [
        'recordState',
        'recordingTime',
    ]),
    ...mapGetters('group', [
       'group'
    ]),
    ...mapGetters('roomSetting', [
       'roomSetting'
    ]),
    isInactive(){
      return this.recordState === 'inactive'
    },
    disabled(){
      return (this.roomSetting && !this.roomSetting.useClientRecord) ||
          this.isGuest() ||
          !this.hasEmceeRole() || 
          this.recordState === 'start' ||
          this.recordState === 'starting' ||
          this.recordState === 'stopping'
    },
    isRecording(){
      return this.recordState === 'recording'
    },
    isPaused(){
      return this.recordState === 'paused'
    },
    recordingFormedTime(){
      return moment.utc(0).millisecond(this.recordingTime).format('HH:mm:ss');
    },
  },
  methods: {    
    ...mapActions('record', [
        'checkReadyToRoomRecord',
        // 'changeRoomRecordState',
        'startRoomRecord',
        'stopRoomRecord',
        'pauseRoomRecord',
    ]),
    ...mapMutations('record', [
      'RECORD_ERROR',
      'CHANGE_CLIENT_RECORD_STATE',
      'CHANGE_CLIENT_RECORD_TIME',
    ]),
    onRecordStart() {
      if(!this.roomSetting.useClientRecord) {
        return this.$alert({
          text: `녹화할 수 없습니다.`,
          onlyOk: true,
        });
      }
      if (this.isGuest() || !this.hasEmceeRole()) {
        return this.$alert({
          text: `${this.isGuest() ? '비회원은' : '참여자는'} 녹화할 수 없습니다.`,
          onlyOk: true,
        });
      }
      this.start();
    },
    timerStart() {
      if(!this.timerIntervalId) {
        this.timerIntervalId = setInterval(() => {
          this.CHANGE_CLIENT_RECORD_TIME(this.recordingTime + this.timerIntervalTerm);
        }, this.timerIntervalTerm)
      }
    },
    timerStop(){
      clearInterval(this.timerIntervalId)
      this.timerIntervalId = null;
      this.CHANGE_CLIENT_RECORD_TIME();
    },
    timerPuase(){
      clearInterval(this.timerIntervalId)
      this.timerIntervalId = null;
    },
    onRecordPause() {
      this.pauseRoomRecord();
    },
    onRecordResume() {
      this.start();
    },
    onRecordStop() {
      this.stop();
    },
    stop() {
      this.stopRoomRecord();
    },    
    async start() {
      if (PcApp.isPcApp()) {
        return;
      }

      if (!this.hasEmceeRole()) {
        return ;
      }
      
      try {
        await this.checkReadyToRoomRecord()
        await this.startRoomRecord();
      } catch (e) {
        let strError;
        
        if (typeof (e) !== 'string') {
          strError = (e && e.message || 'not-supported');
        }
        
        switch (strError || e) {
          case 'permission-denied' :
            this.$alert({
              text: this.$t('extendMenu.record.permissionDenied'),
              onlyOk: true
            });
            break;
          case 'user-cancelled' :
            this.$alert({
              text: this.$t('extendMenu.record.userCancelled'),
              onlyOk: true
            });
            break;
          case 'not-supported':
            this.$alert({
              text: this.$t('extendMenu.record.notSupported'),
              onlyOk: true
            });
            break;
          case 'install-error':
          case 'manual-install-required':
            console.error('gooroomeeMediaExtension install error :', e);

            this.$alert({
              title: this.$t('extendMenu.record.installError.title'),
              text: this.$t('extendMenu.record.installError.text'),
              ok: () => {
                window.open(gooroomeeMediaExtension.getChromeExtensionInstallUrl())
              },
              onlyOk: false
            });
            break;
          case 'permission-activeTab':
            this.$alert({
              text: this.$t('extendMenu.record.permission'),
              onlyOk: true,
              ok: () => {
                this.CHANGE_CLIENT_RECORD_STATE('inactive');
              }
            });
            break;
          case 'get-audio-input-error':
            gooroomeeMediaExtension.Record.createOptionsPageTab();
            break;
          default:
            this.$alert({
              text: this.$t('extendMenu.record.defaultError', { '0' : e }),
              onlyOk: true
            });
            break;
        }        
      } finally {
        this.CHANGE_CLIENT_RECORD_STATE('inactive');
      }
    },
  }
}

const _Events = {
  room_record_forceToStop: function(e) {
    const {data: {reason}} = e;
    this.$alert({
      text: `녹화가 강제로 중지되었습니다.[${reason}]`,
      onlyOk: true
    })
  },
  room_record_recordError: function(e) {
    const {data: {reason}} = e;
    this.$alert({
      text: `녹화실패 [${reason}]`,
      onlyOk: true
    })
  },
}
</script>

<style lang="scss" scoped>
.record-button {
  min-width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: 0.1s ease-out;
  
  //&.disabled {
  //  cursor: not-allowed;
  //  pointer-events: none;
  //}

  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
    &::after {
      content: '';
      width: 100%;
      height: 1px;
      background-color: #0cf;
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
    }
    .recoding {
      display: none;
    }
    .record-controls {
      display: block;
    }
  }
  
  .inactive {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    &::before {
      content: '';
      width: 10px;
      height: 10px;
      margin-bottom: 6px;
      border-radius: 100%;
      background-color: #ff2e55;
      display: block;
    }
    &.disabled {
      color: #777;
      &::before {
        background-color: #777;
      }
    }
  }
  .recoding {}
  .record-text {
    font-size: 12px;
    font-weight: 700;
    color: #ff6480;
    animation: hideAndShow 3s ease-in-out infinite;
    @keyframes hideAndShow {
      0% { opacity: 1; }
      25% { opacity: 0.2; }
      50% { opacity: 1; }
    }
  }
  .record-time {
    margin-top: 2px;
    font-size: 10px;
    color: #fff;
  }
  .record-controls {
    height: 30px;
    padding: 0 10px;
    display: none;
  }
  .record-control-list {
    height: 100%;
    border-radius: 5px;
    background-color: #ff2e55;
    display: flex;
    overflow: hidden;
  }
  .record-control-item {
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    border-left: 1px solid rgba(255, 255, 255, 0.3);
    &:first-of-type {
      border-left: 0;
    }
    &:last-of-type {
      border-right: 0;
    }
  }
  .record-control-button {
    width: 38px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before {
      content: '';
      width: 12px;
      display: block;
      pointer-events: none;
    }
    &.resume {
      &::before {
        height: 100%;
        background: url('~@/assets/images/play_white.svg') no-repeat center / 100% auto;
      }
    }
    &.pause {
      &::before {
        height: 100%;
        background: url('~@/assets/images/pause_white.svg') no-repeat center / 100% auto;
      }
    }
    &.stop {
      &::before {
        height: 12px;
        border-radius: 2px;
        background-color: #fff;
      }
    }
    &:hover {
      opacity: 0.7;
    }
}
//@keyframes blink-effect {
//  50% {
//    opacity: 0;
//  }
//}
//
//.record-btn {
//  .record-btn-state {
//    border-radius: 14px;
//    background-color: lightgrey;
//    width: 14px;
//    height: 14px;
//    margin-right: 10px;
//    padding: 4px;
//  }
//  
//  &.recording .record-btn-state{
//    color: red;
//    background-color: red;
//    animation: blink-effect 2s ease-in-out infinite;
//  }
//
//  &.paused .record-btn-state{
//    background-color: #FF0000;
//    
//    .record-btn-paused {
//      height: 100%;
//      width: 100%;
//      background: url('~@/assets/roomType/lms/img/ico_pause_white.svg') no-repeat;
//      background-size: contain;
//    }
//  }
//
//  &.start,
//  &.starting,
//  &.stopping{
//    cursor: not-allowed;
//    pointer-events: none;
//    
//    .record-btn-state {
//      background-color: #FFA0A0;
//    }
//  }

  //&::after{
  //  content: none !important;
  //}
  
}

</style>